export default class PinnedBox {
  static init() {
    const pinnedBox = document.querySelector('.pinnedbox')

    if (pinnedBox) {
      console.debug('== Pinnedbox component ==')

      const pinnedBoxScrollable = pinnedBox.querySelector('.pinnedbox-right')

      const hScrollable =
        pinnedBoxScrollable.scrollHeight - pinnedBoxScrollable.clientHeight

      let hScrollableCounter = 0
      let scrollDirection = 1

      let prevScrollTop = document.documentElement.scrollTop
      let currrentScrollTop = document.documentElement.scrollTop

      document.addEventListener('scroll', (e) => {
        // detect document scrolling direction
        if (currrentScrollTop > prevScrollTop) {
          scrollDirection = 1
        } else {
          scrollDirection = -1
        }

        let viewportOffset = pinnedBox.getBoundingClientRect()
        let pinnedBoxTop = viewportOffset.top

        // ??
        // sostituire - offset con metà altezza del blocco
        if (pinnedBoxTop <= window.innerHeight / 2 - 100) {
          // il blocco è entrato
          // 1. fermare lo scroll del documento
        }

        // update previous scroll top
        prevScrollTop = document.documentElement.scrollTop
      })
    }
  }
}
